import type { EmailBackfill } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchEmailBackfills(context: ApiContext) {
  return apiContextFetch<EmailBackfill[]>(context, "email_integration_backfills")
}
